import { makeStyles } from "@material-ui/core/styles";
// import { preDefinedThemeColor } from "./preDefinedColor";
// const preDefinedColor = preDefinedThemeColor;

export const useStyles = makeStyles((theme) => ({
    driverDetailsContainer: {
        minHeight: '208px'
    },
    driverDetailsContainerExpanded: {
        minHeight: '297px'
    },
    table: {
        // tableLayout: "fixed",
    },
    tablePagination: {
        "& .MuiSelect-select.MuiSelect-select": {
            marginTop: "5px",
        },
    },
    scoreValueSkeleton: {
        transform: "scale(1, 1) !important",
    },
    loadingContainer: {
        padding: "1.6em",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    driverInfoContailer: {
        // padding: "2em 2.75em",
        [theme.breakpoints.up("sm")]: {
            display: "flex",
        },
        height: '100%'
    },
    driverInfoItem: {
        height: '100%'
    },
    driverScoreInfoCard: {
        flex: '1',
        display: 'flex',
        alignItems: 'center'
    },
    driverInfoCardCollpase: {
        display: 'flex',
        marginLeft: theme.typography.pxToRem(103),
        marginRight: "0px",
        flex: 1
    },
    driverInfoCardExpand: {
        display: 'flex',
        marginLeft: theme.typography.pxToRem(136),
        marginRight: "0px",
        flex: 1
    },
    driverPraisoRank: {
        display: 'flex',
        // justifyContent: "space-between",
        alignItems: "center"
    },
    root: {
        width: "100%",
    },
    headerTitle: {
        fontWeight: 500,
        fontSize: "20px",
        color: "rgb(36,42,56)",
    },
    headerDate: {
        textAlign: "right",
        color: "rgb(175 179 187)",
        marginBottom: theme.spacing(2.5),
        fontSize: "1.1em",
        fontWeight: 400,
    },
    mapView: {
        height: "100vh",
    },
    mapSidebarContainer: {
        position: 'relative',
        width: 400,
        zIndex: 999
    },
    mapSidebar: {
        position: 'absolute',
        left: 0,
        top: 0
    },
    collapseIcon: {
        position: 'absolute',
        left: 0,
        top: 0
    },
    expandIcon: {
        position: 'absolute',
        right: 65,
        top: 0
    },
    actionExpandCollapseBtn: {
        backgroundColor: '#FFFFFF',
        height: "30px",
        fontSize: "14px",
        fontWeight: 200,
        color: "rgb(132,135,143)",
    },
    driverCard: {
        padding: "2em 2.75em",
        marginBottom: "2em",
        position: "relative",
        display: "block",
        [theme.breakpoints.up("md")]: {
            minWidth: "450px",
            display: "flex",
        },
    },
    driverInfoCard: {
        padding: "2em 2.75em",
        [theme.breakpoints.up("sm")]: {
            display: "flex",
            flexDirection: 'column',
            height: '100%'
        },
    },
    driverDetails: {
        display: 'flex',
        alignItems: 'center'
    },
    imageIcon: {
        margin: theme.spacing(0, 0, 0, 4)
    },
    driverAvatar: {
        color: "rgb(91,90,90)",
        backgroundColor: "#e6ebf1",
        width: "110px",
        height: "110px",
        fontSize: theme.typography.pxToRem(45),
        textTransform: "uppercase",
        fontWeight: 500,
        marginRight: theme.typography.pxToRem(25),
        transition: 'all 0.5s ease'
    },
    driverAvatarExpanded: {
        color: "rgb(91,90,90)",
        backgroundColor: "#e6ebf1",
        width: "78px",
        height: "78px",
        fontSize: theme.typography.pxToRem(31),
        textTransform: "uppercase",
        fontWeight: 500,
        marginRight: theme.typography.pxToRem(25),
        transition: 'all 0.5s ease'
    },
    driverAvatarDisabled: {
        paddingTop: "0",
    },
    driverName: {
        fontWeight: 500,
        fontSize: "1.4em",
        // marginTop: "28px",
        // marginBottom: "2px",
        textTransform: "capitalize",
    },
    driverNameApiFailed: {
        marginTop: "0",
        marginBottom: "0",
    },
    engagementDate: {
        color: "rgb(132,135,143)",
    },
    dividerContainer: {
        width: '100%',
        margin: '16px 0px'
    },
    arrowUpIcon: {
        marginRight: "5px",
    },
    arrowRightIcon: {
        marginRight: "5px",
    },
    arrowDownIcon: {
        marginRight: "5px",
    },
    rankingText: {
        fontSize: "1.5em",
        fontWeight: 500,
        "& span": {
            fontSize: "0.58em",
            color: "rgb(132,135,143)",
            fontWeight: 500,
            display: "block",
        },
    },
    rankingInfoText: {
        fontSize: "1.5em",
        fontWeight: 500,
        "& span": {
            fontSize: "0.58em",
            color: "rgb(132,135,143)",
            fontWeight: 500,
            display: "block",
        },
    },
    driverEmail: {
        fontSize: "1.5em",
        // fontWeight: 500,
        "& span": {
            fontSize: "0.65em",
            color: "rgb(132,135,143)",
            // fontWeight: 500,
            display: "block",
        },
    },

    statusText: {
        fontSize: "1.5em",
        fontWeight: 500,
        "& span": {
            fontSize: "0.65em",
            color: "rgb(0,0,0)",
            // fontWeight: 500,
            display: "block",
        },
    },

    preferedVehicleText: {
        fontSize: "1.5em",
        fontWeight: 500,
        "& span": {
            fontSize: "0.58em",
            color: "rgb(132,135,143)",
            fontWeight: 500,
            display: "block",
            width: "max-content"
        },
    },

    rankingContainer: {
        flexDirection: "column",
        alignItems: "flex-start",
        [theme.breakpoints.up("lg")]: {
            flexDirection: "row",
        },
        marginTop: "15px",
    },

    rankingDetailContainer: {
        flexDirection: "column",
        alignItems: "flex-start",
        [theme.breakpoints.up("lg")]: {
            flexDirection: "row",
        },
        marginTop: "15px",
    },

    ranking: {
        padding: "0 0 10px 0",
        marginRight: "20px",
        "& .MuiGrid-item": {
            width: "40%",
            margin: "0 20px 20px 0",
        },
        width: "100%",
        [theme.breakpoints.up("md")]: {
            "& .MuiGrid-item": {
                width: "120px",
                margin: "0 20px 0 0",
            },
        },
        [theme.breakpoints.up("lg")]: {
            width: "unset",
            borderRight: "2px solid rgba(222,222,222,0.5)",
            "&:first-of-type": {
                "& .MuiGrid-item:first-of-type": {
                    marginLeft: 0,
                },
            },
            "& .MuiGrid-item": {
                maxWidth: "100px",
                margin: "0 20px",
            },
        },
    },
    rankingLast: {
        borderRight: "unset",
    },
    tabs: {
        padding: 0,
        "& .MuiTab-root": {
            minWidth: "auto",
            padding: "0",
            margin: "0 20px 0 0",
            textTransform: "capitalize",
            fontSize: "1.3em",
        },
        "& .Mui-selected .MuiTab-wrapper": {
            color: "rgb(36,42,56)",
        },
        "& .MuiTab-wrapper": {
            color: "rgb(143,143,143)",
        },
        "& .MuiTabs-indicator": {
            height: "3px",
        },
    },
    tabPanel: {
        // "& > .MuiBox-root": {
        //     margin: theme.spacing(3, 0),
        // },
        "& > .customPraisoHeader": {
            margin: theme.spacing(3, 0, 0.2),
        },
    },
    tableTabContainer: {
        marginLeft: "0",
        marginRight: "0",
    },
    statusMessage: {
        position: "absolute",
        top: "10px",
        right: "0",
        fontSize: "14px",
        fontWeight: 500,
        backgroundColor: "rgb(241,242,246)",
        padding: "10px 40px 8px 30px",
        borderRadius: "50px 0 0 50px",
        color: "rgb(0,0,0)",
        "& span": {
            fontSize: "12px",
            color: "rgb(132,135,143)",
            marginRight: "20px",
        },
    },
    tableContainer: {
        "& .MuiTableCell-root": {
            borderBottom: "2px solid rgb(241,242,246)",
            padding: "20px 40px",
        },
        "& .MuiTableCell-footer": {
            padding: "2px",
        },
    },
    tableFooter: {
        backgroundColor: "#F1F2F6",
        "& .MuiTableCell-footer": {
            border: 0,
            paddingTop: `${theme.spacing(5)}px !important`,
        },
    },
    title: {
        marginBottom: 0,
        fontWeight: 500,
        fontSize: "1em",
        color: "#000",
        "& span": {
            color: "rgb(163,171,182)",
            display: "block",
            fontSize: "0.9em",
            marginTop: "5px",
        },
    },
    bgWhite: {
        backgroundColor: "rgba(255, 255, 255, 1)",
    },
    severeRow: {
        paddingTop: "10px!important",
        paddingBottom: "10px!important",
    },
    severityIcon: {
        backgroundColor: "rgb(205, 4, 4)",
        color: "#fff!important",
        padding: 0,
        borderRadius: "20px",
        height: "40px",
        width: "40px",
        display: "inline-flex!important",
        alignItems: "center",
        justifyContent: "center",
        "& img": {
            width: "100%",
        },
    },
    sortArrow: {
        cursor: "pointer",
        marginLeft: "8px",
    },
    speedingCol: {
        display: "inline-flex",
        alignItems: "center",
    },
    viewAsDriver: {
        cursor: 'pointer',
        fontSize: 17,
        fontWeight: 200,
    },
    activeSinceContainer: {
        display: 'flex',
        justifyContent: 'flex-start'
    },
    driverViewBtn: {
        margin: "2px 8px",
        height: "30px",
        width: "150px",
        borderRadius: '30px',
        fontSize: "1rem",
        fontWeight: 400,
        // [theme.breakpoints.down("xs")]: { marginTop: '10px', marginLeft: '0px' },
    },
    addLicenseBtn: {
        height: "35px",
        marginTop: theme.spacing(0.5),
        // fontSize: "1rem",
        borderRadius: '30px',
        paddingLeft: "20px",
        paddingRight: "20px",
        marginLeft: theme.spacing(2.5),
    },
    iconContainer: {
        position: 'relative',
    },
    editIcon: {
        float: "right",
        top: 0,
        right: 0,
        margin: '8px'
    },
    fabButton: {
        top: '140px',
        right: '40px',
        position: 'fixed',
        height: '64px',
        width: '64px',
        "z-index": 999
    },
    plus: {
        marginLeft: '15px',
        marginTop: '15px',
    },
    note: {
        height: '40px',
        width: '32px',
        position: 'absolute',
    },
    rightSliderContainer: {
        top: '80px',
        right: '-50%',
        position: 'absolute',
        width: '50%',
        height: "100%",
        background: 'white',
        maxWidth: '1000px',
        minWidth: '400px',
        boxShadow: '0px 3px 3px -2px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 1px 8px 0px rgba(0,0,0,0.12)',
        zIndex: 10,
        transition: 'right 0.4s ease-out',
        // overflowX: 'hidden',
    },

    licenceDetailsCard: {
        marginBottom: theme.spacing(2.5),
        marginTop: theme.spacing(0.5),
        marginLeft: theme.spacing(2.5),
        padding: "20px",
        background: "#fffbeb",
    },
    licenceDetailsWrapper: {
        display: "flex",
        // margin: theme.spacing(1, 0),
        justifyContent: 'space-between',
    },
    licenceNumber: {
        marginTop: '16px',
        marginRight: '32px',
    },
    licenceExpiry: {
        // padding: theme.spacing(1.5, 1, 1.5, 1),
        display: 'flex',
        // flexWrap: 'wrap'
        flexDirection: 'column',
        justifyContent: 'space-between',
        // alignItems: 'flex-start'

    },
    licenseNoBlock: {
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'unset',
    },
    licenceHead: {
        fontSize: 14,
        color: 'rgb(153, 164, 184)',
        fontWeight: 500,
        width: '100%'
    },
    licenceNumberText: {
        fontSize: 14,
        color: 'rgb(0, 0, 0)',
        fontWeight: 500,
        marginTop: '4px',
        width: '100%'
    },
    licenceContent: {
        fontSize: 14,
        color: 'rgb(0, 0, 0)',
        fontWeight: 500,
        marginTop: '4px',
        // marginTop: '28px',
    },
    tag: {
        height: theme.spacing(2),
        fontSize: 10,
        margin: theme.spacing(1, 0.5, 0, 0),
        padding: theme.spacing(0.125, 1, 0, 1),
        backgroundColor: "rgb(255, 211, 40)",
        borderRadius: '10px',
        color: "rgb(255, 255, 255)",
    },

    expiryTag: {
        height: theme.spacing(2),
        fontSize: 10,
        margin: theme.spacing(1, 0.5, 0, 0),
        padding: theme.spacing(0.125, 1, 0, 1),
        backgroundColor: "rgb(255, 220, 205)",
        borderRadius: '10px',
        color: "rgb(209, 1, 1) !important",
    },
}));
